module.exports = __webpack_public_path__ + "img/logo_full.91b446bd.png";